import 'css-chunksrc/client/pages/utilityPage/projectModelsPage/loader/styles.scss';export default {
  "models": "_models_cyvsm_1",
  "model": "_model_cyvsm_1"
};